// extracted by mini-css-extract-plugin
export default {"save":"Rdp-module__save__dWwWh","save-mobile":"Rdp-module__save-mobile__Yrfjo","save-desktop":"Rdp-module__save-desktop__t1cdv"};